import { createApp } from 'vue'
import Auction from './views/Auction.vue'

const app = createApp(Auction)

app.mount('#auctionPreview')